import React from 'react';
import {
  ViewerContainer,
  GridContainer,
  GridItemImage,
  GridItemText,
  ImageElement,
  Text,
} from 'pages/DocumentBuilder/components/HeaderSection/HeaderSection.styled';
import { HeaderElement } from 'features/document/constants';
import { useGetFileQuery } from 'features/files/filesApi';

interface Props {
  header: HeaderElement;
  isIndividualHeaderVisible: boolean;
}

const ViewerHeaderSection: React.FC<Props> = ({ header, isIndividualHeaderVisible }) => {
  const { data } = useGetFileQuery(Number(header.content.logo.id), { skip: header.content.logo.id === null });

  const { content, style } = header;

  return (
    <ViewerContainer
      aria-hidden='true'
      backgroundColor={content.hasBackgroundColor && isIndividualHeaderVisible ? style.backgroundColor : ''}
    >
      {isIndividualHeaderVisible && (
        <GridContainer container justifyContent='space-between' alignItems='center'>
          <GridItemImage item xs={6}>
            {content.hasLogo && content.logo.id && <ImageElement src={data?.data.url} alt='logo' />}
          </GridItemImage>
          <GridItemText item xs={6}>
            <Text fontSize={style.labelFontSize} labelFont={style.labelFont} fontColor={style.fontColor}>
              {content.hasHeaderDetails && content?.text}
            </Text>
          </GridItemText>
        </GridContainer>
      )}
    </ViewerContainer>
  );
};

export default ViewerHeaderSection;
